import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
//import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
//import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import ReactPlayer from "react-player";
//import { Divider } from "@material-ui/core";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
// import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Markdown from "markdown-to-jsx";
import Link from "@material-ui/core/Link";
/* eslint import/no-webpack-loader-syntax: off */
import Notes from "!raw-loader!./Notes.md";

const styles = theme => ({
  card: {
    minWidth: 275
  },
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    maxWidth: "80%"
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  }
});
function SimpleCard(props) {
  const { classes } = props;

  const mdconfig = {
    overrides: {
      ReactPlayer: {
        component: ReactPlayer
      },
      h1: {
        component: Typography,
        props: {
          variant: "h5"
        }
      },
      h2: {
        component: Typography,
        props: {
          variant: "h6"
        }
      },
      h3: {
        component: Typography,
        props: {
          variant: "h6",
          color: "textSecondary",
          className: classes.para
        }
      },
      a: {
        component: Link,
        props: {
          target: "_blank"
        }
      },
      p: {
        component: Typography,
        props: {
          paragraph: true,
          className: classes.para
        }
      },
      ul: {
        component: Typography,
        props: {
          component: "ul",
          className: classes.para
        }
      },
      em: {
        props: {
          className: classes.para
        }
      },
      pre: {
        props: {
          // className: "w3-panel w3-card w3-light-grey"
          className: "w3-card "
        }
      },
      code: {
        props: {
          className: "w3-code jsHigh notranslate"
        }
      }
    }
  };

  return (
    <div>
      <Card className={classes.card}>
        <CardContent>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            Apr 10, 2019
          </Typography>
          <Markdown options={mdconfig}>{Notes}</Markdown>
        </CardContent>
      </Card>
      <br />
    </div>
  );
}

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimpleCard);
